export { ConnectedCheckoutPaymentBlockPromoCode } from './CheckoutPaymentBlockPromoCode';
